import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  LineController,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { observer } from "mobx-react";
import dashboardStore from "../../../../store/dashboardStore";
import React from "react";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  LineController,
  Tooltip,
  Legend,
  Title
);

const generateReductionSeries = (length, baseEmission, reductionRate) => {
  const fixedDecrease = baseEmission * (reductionRate / 100); // 固定扣除量
  const result = [];

  let current = baseEmission;

  for (let i = 0; i < length; i++) {
    // ⭐ 確保不會低於 0
    result.push(Math.max(Math.round(current), 0));

    current = current - fixedDecrease;
  }

  return result;
};

export const MixedChart = observer(() => {
  const store = dashboardStore;
  let reductionArr = [];
  if (
    store.mixedChartData.baseEmission &&
    store.mixedChartData.annualReductionRate >= 0
  ) {
    reductionArr = generateReductionSeries(
      11,
      store.mixedChartData.baseEmission,
      store.mixedChartData.annualReductionRate
    );
  }
  const labels = store.actualData?.data?.map((item) => String(item.year));
  const barData = store.actualData?.data?.map((item) => String(item.value));
  //   const barData = [
  //     100000, 98000, 95000, 92000, 90000, 88000, 86000, 84000, 82000, 80000,
  //     78000,
  //   ];

  const data = {
    labels,
    datasets: [
      {
        type: "bar",
        label: "Actual (tCO₂e)",
        data: barData,
        backgroundColor: "rgba(60, 130, 245, 1)",
        barThickness: 60,
        order: 2,
      },
      {
        type: "line",
        label: "Planned (tCO₂e)",
        data: reductionArr,
        backgroundColor: "rgba(75, 220, 125, 1)",
        borderColor: "rgba(75, 220, 125, 1)",
        borderWidth: 2,
        tension: 0,
        pointRadius: 4,
        fill: false,
        order: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // ⭐⭐ 要吃父層高度必加這行 ⭐⭐
    plugins: {
      title: { display: false },
      legend: { position: "top" },
    },
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Bar data={data} options={options} />
    </div>
  );
});
